export default "__VITE_ASSET__DBBo26gw__"